import React from 'react'
import Grid from '@mui/material/Grid';
import CarInfo from './CarInfo';
import { v4 as uuidv4 } from 'uuid';



export default function RowOfCars(props) {
    return (
        <Grid container spacing={1}>
            <Grid item xs={6} md={3}>
                {props.data[0] ? <CarInfo key={uuidv4()} data={props.data[0]}/> : null}
            </Grid>
            <Grid item xs={6} md={3}>
                {props.data[1] ? <CarInfo key={uuidv4()}  data={props.data[1]}/> : null}
            </Grid>
            <Grid item xs={6} md={3}>
                {props.data[2] ? <CarInfo key={uuidv4()} data={props.data[2]}/> : null}
            </Grid>
            <Grid item xs={6} md={3}>
                {props.data[3] ? <CarInfo key={uuidv4()} data={props.data[3]}/> : null}
            </Grid>
        </Grid>
    )
}
